import type { ReactNode } from 'react';
import { BottomNav } from '../BottomNav/BottomNav';
import { useAppHeight } from '../../app/useAppHeight';
import './Layout.css';

interface LayoutProps {
  children: ReactNode;
  /**
   * Pinned above the content, below the nav - for floating buttons.
   *
   * This is a slot rather than something a page positions itself because the
   * shell is the only box that is exactly the viewport and does not scroll.
   * Absolute inside `.layout__content` would scroll away with the content, and
   * `position: fixed` desyncs from the layout viewport on iOS - the bug that
   * made the bottom nav drift.
   */
  overlay?: ReactNode;
}

export function Layout({ children, overlay }: LayoutProps) {
  // The shell is the only box that is exactly the viewport, so it is the right
  // place to keep that measurement honest. Every page renders through here.
  useAppHeight();

  return (
    <div className="layout">
      <main className="layout__content">{children}</main>
      {overlay && <div className="layout__overlay">{overlay}</div>}
      <BottomNav />
    </div>
  );
}
